var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduler-+-Profile-Association",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person-Scheduler---weekly-many-custom-Copy",
    transform: "translate(-681.000000, -386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(682.000000, 387.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#5f00a0",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#5f00a0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uE8FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.68,6.48 L19.6533333,8.50666667 L15.4933333,4.34666667 L17.52,2.32 C17.7333344,2.1066656 17.995554,2 18.3066667,2 C18.6177793,2 18.8799989,2.1066656 19.0933333,2.32 L21.68,4.90666667 C21.8933344,5.12000107 22,5.38222067 22,5.69333333 C22,6.004446 21.8933344,6.2666656 21.68,6.48 Z M2,17.84 L14.2933333,5.54666667 L18.4533333,9.70666667 L6.16,22 L2,22 L2,17.84 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.85beed71325929d4efc08dad2c9dbdd8.svg";
export { ForwardRef as ReactComponent };